//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps';

export default {
  name: "mapAuth",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      ymapInstance: null,
      scrollZoom: true,
      coords: [55.76135006899107, 37.63297850000001],
      markers: [
        {
          layout: 'default#imageWithContent',
          imageHref: 'img/icons/map-marker.svg',
          imageSize: [20, 20],
          imageOffset: [0, 0],
          coords: [55.76135006899107, 37.63297850000001],
          id: '0'
        },
        {
          layout: 'default#imageWithContent',
          imageHref: 'img/icons/map-marker.svg',
          imageSize: [20, 20],
          imageOffset: [0, 0],
          coords: [59.980240564123804, 30.326881499999992],
          id: '1'
        },
        {
          layout: 'default#imageWithContent',
          imageHref: 'img/icons/map-marker.svg',
          imageSize: [20, 20],
          imageOffset: [0, 0],
          coords: [56.312455, 43.991200],
          id: '2'
        },
        {
          layout: 'default#imageWithContent',
          imageHref: 'img/icons/map-marker.svg',
          imageSize: [20, 20],
          imageOffset: [0, 0],
          coords: [58.010736, 56.281887],
          id: '3'
        },
      ],
      active_tab: 0,
      tabs: [
        {
          tab_title: "Москва",
          tab_content:
            "Нажмите на карту для выбора подразделения или учебного офиса ВШЭ",
          phone: '+7 (495) 771-32-42, +7 (495) 916-88-44',
          email: 'abitur@hse.ru',
          postcode: '101000',
          address: 'ул. Мясницкая, д. 11',
          coords: [55.76135006899107, 37.63297850000001],
        },
        {
          tab_title: "Нижний Новгород",
          tab_content:
            "Нажмите на карту для выбора подразделения или учебного офиса ВШЭ",
          phone: '+ 7 831 432-78-76',
          email: 'pknn@hse.ru',
          postcode: '603000',
          address: 'ул. Костина, д. 2',
          coords: [56.312455, 43.991200]
        },
        {
          tab_title: "Пермь",
          tab_content:
            'Нажмите на карту для выбора подразделения или учебного офиса ВШЭ',
          phone: '8 (342) 200-96-96',
          email: 'abitur.perm@hse.ru',
          postcode: '614070',
          address: 'ул. Студенческая, 38',
          coords: [58.01061706656195, 56.283405000000016]
        },
        {
          tab_title: "Санкт-Петербург",
          tab_content:
            'Нажмите на карту для выбора подразделения или учебного офиса ВШЭ',
          phone: '+7 (812) 644-62-12, +7 (812) 980-00-30',
          email: 'abitur-spb@hse.ru',
          postcode: '190121',
          address: 'ул. Кантемировская, д. 3, к. 1, лит А, ауд. 239',
          coords: [59.980240564123804, 30.326881499999992]
        },
      ]
    };
  },
  methods: {
    changeTab(tabIndexValue, tab) {
      this.active_tab = tabIndexValue;
      this.coords = tab.coords
    },
    intitMapInstance(e) {
      this.ymapInstance = e
    },
    enableScrollZoom() {
      this.ymapInstance.behaviors.enable('scrollZoom')
    }
  }
}
